// Interface languages: uz (default, Latin), en, ru.
//
// Strings live in src/locales/<lang>/<namespace>.json and are picked up automatically
// (one namespace per page or component, plus `common` for shared words). Use:
//   const { t } = useTranslation("<namespace>");  then t(<key>) or t(<"common:" + key>)
// The chosen language is stored in the user's profile (users.language) and in
// localStorage (for the login page); axios sends it as Accept-Language so API
// messages come back in the same language.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';

export const LANGUAGES = [
  { code: 'uz', label: "O'zbekcha", short: 'UZ' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'ru', label: 'Русский', short: 'RU' },
];
export const DEFAULT_LANGUAGE = 'uz';
const STORAGE_KEY = 'lang';
// Intl locale per language (numbers, dates)
export const INTL_LOCALE = { uz: 'uz-Latn-UZ', en: 'en-US', ru: 'ru-RU' };

const resources = {};
const ctx = require.context('../locales', true, /^\.\/(uz|en|ru)\/[\w-]+\.json$/);
ctx.keys().forEach((key) => {
  const [, lang, ns] = key.match(/^\.\/(uz|en|ru)\/([\w-]+)\.json$/);
  resources[lang] = resources[lang] || {};
  resources[lang][ns] = ctx(key);
});

const stored = (() => {
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
})();
const initial = LANGUAGES.some((l) => l.code === stored) ? stored : DEFAULT_LANGUAGE;

const applyLanguage = (lng) => {
  axios.defaults.headers.common['Accept-Language'] = lng;
  document.documentElement.lang = lng;
};
applyLanguage(initial);

i18n.use(initReactI18next).init({
  resources,
  lng: initial,
  fallbackLng: DEFAULT_LANGUAGE,
  ns: Object.keys(resources[DEFAULT_LANGUAGE] || { common: {} }),
  defaultNS: 'common',
  fallbackNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on('languageChanged', (lng) => {
  applyLanguage(lng);
  try { localStorage.setItem(STORAGE_KEY, lng); } catch { /* private mode */ }
});

export default i18n;
